<template>
  <v-container fluid class="px-0 py-1">
    <LogTable
      v-show="!showEditDialog"
      :internship.sync="internship"
      v-on:newLog="showEditDialog = true"
      v-on:shareLog="shareSelected()"
      ref="table"
      class="mb-5"
    />
    <v-slide-y-reverse-transition>
      <v-card class="ma-3 card-rounded" flat v-show="showEditDialog">
        <LogForm
          :internship.sync="internship"
          v-if="showEditDialog"
          :close="closeEditLogForm"
        />
      </v-card>
    </v-slide-y-reverse-transition>
    <v-dialog
      v-model="share"
      :persistent="true"
      :fullscreen="isMobile"
      :max-width="600"
      lazy
      style="overflow-y: inherit"
    >
      <SelectUsers
        :users="selectedUsers"
        @updateSelectedUsers="updateSelectedUsers"
        :submitSharedLogs="submitSharedLogs"
        :close="closeShareOption"
      />
    </v-dialog>
    <v-btn
      v-if="isMobile"
      fixed
      dark
      fab
      bottom
      right
      color="indigo"
      @click="showEditDialog = true"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import LogTable from '@/views/Logbook/components/LogTable'
import LogForm from '@/views/Logbook/components/LogForm'
import SelectUsers from '@/views/Logbook/components/SelectUsers'
import specialtyFetcher from '../../mixins/specialtyFetcher'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    LogTable,
    LogForm,
    SelectUsers
  },

  mixins: [specialtyFetcher],
  data() {
    return {
      internship: '',
      showEditDialog: false,
      requiredValidators: {
        'anesthesia-procedure': log =>
          log['general-anesthesia'] ||
          log['loco-regional-anesthesia'] ||
          log['sedoanalgesia'] ||
          log['cam']
      },
      selectedUsers: [],
      share: false,
      selectedRows: [],
      expandDialog: false
    }
  },
  computed: {
    ...mapGetters(['username']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    logbookLabel() {
      const specialtyLabels = {
        anesthesiology: 'Anestesiologia',
        'general-surgery': 'Cirurgia Geral'
      }
      return (
        specialtyLabels[this.$store.getters.specialty] ||
        this.$t('common.Logbook')
      )
    }
  },

  methods: {
    ...mapActions([
      'addNotifications',
      'getSharedLogs',
      'getSharedNotifications',
      'showSuccessSnackbar',
      'showErrorSnackbar'
    ]),
    isUserValid(internship, specialty) {
      /*  // user's specialty allows the creation of an internship of the shared log
      const validInternship = InternshipsSpecialty.query()
        .where(
          l =>
            l.internshipSpeciality === this.$store.getters.specialty &&
            l.specialities.includes(specialty)
        )
        .get()*/
      return (
        specialty === this.$store.getters.specialty || internship === specialty
        //   || validInternship.length
      )
    },
    closeEditLogForm() {
      this.showEditDialog = false
    },

    updateSelectedUsers(selectedUsers) {
      this.selectedUsers = selectedUsers
    },
    deleteSelected() {
      this.$refs.table.deleteSelected()
    },
    shareSelected() {
      this.selectedRows = this.$refs.table.shareSelected()
      if (this.selectedRows && this.selectedRows.length >= 1) {
        this.share = true
      }
    },
    cloneSelected() {
      this.$refs.table.cloneSelected()
    },
    closeLogForm() {
      this.showDialog = false
    },
    closeShareOption() {
      this.share = false
      this.selectedUsers = []
      this.selectedRows = []
      this.$refs.table.selected = []
    },
    async submitSharedLogs() {
      await this.addLogsToCollegues(this.selectedRows, this.selectedUsers)
      this.closeShareOption()
    },
    async addLogsToCollegues(selectedRows, selectedUsers) {
      const userId = this.$store.getters.profile.id
      const sharedLogs = await this.logsValidations(
        selectedRows,
        selectedUsers,
        userId
      )
      let logsResult = []
      // logsResult = for each selected log add a new line for each user
      const logs = selectedRows.map(row => {
        return this.addLogs(row, selectedUsers, userId, sharedLogs)
      })
      logsResult = logs.reduce((acc, cur) => [...acc, ...cur], [])
      if (!logsResult.length) {
        this.showErrorSnackbar(
          'Registo(s) já partilhado(s) ou partilha não permitida para Colegas de outras especialidades '
          // 'Registo(s) já partilhado(s)'
        )
      } else {
        this.addNotifications(logsResult).then(() =>
          this.showSuccessSnackbar('Logbook(s) partilhado(s) com sucesso')
        )
      }
    },
    async logsValidations(selectedRows, selectedUsers, userId) {
      let sharedLogs = []
      if (selectedRows.length && selectedUsers.length) {
        // 1st: get logs that are already in the logs table (already shared)
        if (selectedRows[0].id) {
          await this.getSharedLogs(selectedRows.map(r => r.id)).then(logs => {
            sharedLogs = logs.map(log => {
              const Logs = {}
              Logs.userId = log.userId
              Logs.sharedId = log.sharedId
              Logs.sharedUser = log.sharedUser
              Logs.sharedDate = log.sharedDate
              return Logs
            })
          })
        }
        // 2nd: get logs that are for approval in the notifications table
        let sharedNotifications = []
        await this.getSharedNotifications(selectedUsers.map(r => r.value)).then(
          notifications => {
            sharedNotifications = notifications.map(notification => {
              if (notification.metadata.log.sharedUser === userId) {
                const Logs = {}
                Logs.userId = notification.metadata.log.userId
                Logs.sharedId = notification.metadata.log.sharedId
                Logs.sharedUser = notification.metadata.log.sharedUser
                Logs.sharedDate = notification.metadata.log.sharedDate
                return Logs
              }
            })
          }
        )
        sharedLogs = [...sharedLogs, ...sharedNotifications.filter(n => n)]
        return sharedLogs
      }
    },
    addLogs(row, users, id, sharedLogs) {
      // check if  user can create the log or if user already has the log
      const logResult = users.map(user => {
        if (
          this.isUserValid(row.internship, user.specialty) &&
          !sharedLogs.find(
            l => l.userId === user.value && l.sharedId === row.id
          ) &&
          row.sharedUser != user.value
        ) {
          const notification = {}
          notification.userId = user.value
          notification.createdAt = new Date()
          notification.type = 'ShareLog'
          notification.header = 'Log para aprovação'
          notification.text = 'Log partilhado por' + ' ' + this.username
          notification.metadata = {
            sharedUserinternship: row.internship ? row.internship : null,
            sharedUserSpecialty: this.$store.getters.specialty,
            log: {
              ...row,
              _id: null,
              id: null,
              createdAt: null,
              userId: user.value,
              internship: null,
              sharedUser: id,
              sharedId: row.id,
              sharedDate: notification.createdAt
            }
          }

          delete notification.metadata.log._id

          return notification
        }
      })
      return logResult.filter(log => log)
    }
  },
  mounted() {
    const thisInstance = this
    this.$root.$on(
      'addLogsToCollegues',
      function (selectedRows, selectedusers) {
        thisInstance.addLogsToCollegues(selectedRows, selectedusers)
      }
    )
    if (this.$route.params && this.$route.params.openDialog) {
      this.showEditDialog = true
    }
  }
}
</script>

<style></style>
